import { Api } from '../AApi'

export const API_OVERVIEW = new Api(
  {},
  {
    logFileIndex: {
      async request(params) {
        return this.sdk
          .request({
            method: 'get',
            url: `log-file-errors`,
            params,
          })
          .then((res) => res.data)
      },
    },
    previewFile: {
      async request(params) {
        return this.sdk
          .request({
            method: 'get',
            url: `view-log-file`,
            params,
          })
          .then((res) => res.data)
      },
    },
    destroy: {
      async request(params) {
        return this.sdk
          .request({
            method: 'delete',
            url: `log-file-errors`,
            params,
          })
          .then((res) => res.data)
      },
    },
    getSummaryData: {
      async request() {
        return this.sdk
          .request({
            method: 'get',
            url: `dashboard/systemSummary`,
          })
          .then((res) => res.data)
      },
    },
  }
)
